import { Button, Chip, ListItemText, Paper } from '@mui/material'
import { SectionHeader } from '@sitoo/mui-components'
import { useTranslation } from 'react-i18next'
import { ListItemSkeleton } from '../../../../components/list-item-skeleton'

type Props = {
  isConfigured: boolean
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
}

export const AuthenticationSection = (props: Props) => {
  const { isConfigured, onClick, disabled, isLoading } = props
  const { t } = useTranslation(['shared', 'apps'])

  return (
    <Paper>
      <SectionHeader variant="transparent">
        {t('apps:authentication.title')}
      </SectionHeader>

      <ListItemSkeleton
        component="div"
        secondaryAction={
          <Button
            color="secondary"
            size="small"
            disabled={disabled}
            onClick={onClick}
            data-testid="authentication-section-button"
          >
            {isConfigured ? t('shared:action.replace') : t('shared:action.set')}
          </Button>
        }
        isLoading={isLoading}
        childrenSkeleton
        hasSecondaryText
        sx={{
          '.MuiListItemText-secondary': { height: '17px' }, // Chip height
        }}
      >
        <ListItemText
          secondary={
            <Chip
              component="span"
              label={
                isConfigured
                  ? t('apps:authentication.configured')
                  : t('apps:authentication.not_configured')
              }
              color={isConfigured ? 'blue' : 'red'}
              data-testid="authentication-section-status"
            />
          }
        >
          {t('apps:authentication.status')}
        </ListItemText>
      </ListItemSkeleton>
    </Paper>
  )
}
